export enum OutputType {
  CONDITION = 'CONDITION',
  SIGNAL = 'SIGNAL',
}

export enum OnnxResultType {
  OnnxPredictionModel = 'OnnxPredictionModel',
  OnnxAnomalyModel = 'OnnxAnomalyModel',
}

export const DEFAULT_DURATION = { value: 0, units: 'min' };

export const MODEL_PARAMETER_NAME = 'model';

export const getPositionalInputName = (index: number) => `input${index + 1}`;
